/* Native Shopify contact delivery; no external endpoint, local PII storage or messaging API. */
(() => {
  if (window.ukuWaitlistV2) return;
  window.ukuWaitlistV2 = true;
  const initialise = (root = document) => {
    root.querySelectorAll('form.uku-waitlist-form').forEach((form) => {
      if (form.dataset.ukuReady) return;
      form.dataset.ukuReady = 'true';
      const emailOpt = form.querySelector('[data-email-consent]');
      const waOpt = form.querySelector('[data-whatsapp-consent]');
      const phone = form.querySelector('[data-whatsapp-phone]');
      const phoneGroup = form.querySelector('[data-whatsapp-details]');
      const prefs = form.querySelector('[data-update-preferences]');
      const request = form.querySelector('[data-waitlist-request]');
      const error = form.querySelector('[data-form-error]');
      const submit = form.querySelector('button[type="submit"]');
      if (!emailOpt || !waOpt || !phone || !prefs || !request || !submit) return;
      const compactPhone = () => phone.value.replace(/[\s().-]/g, '');
      const isRemoval = () => request.value === 'Remove me from the waitlist';
      const sync = () => {
        const removing = isRemoval();
        prefs.disabled = removing;
        const needsPhone = !removing && waOpt.checked;
        phoneGroup.hidden = !needsPhone;
        phone.disabled = !needsPhone;
        phone.required = needsPhone;
        phone.setCustomValidity(needsPhone && phone.value && !/^\+[1-9]\d{7,14}$/.test(compactPhone()) ? 'Enter your WhatsApp number with a country code, for example +919876543210.' : '');
        emailOpt.setCustomValidity(!removing && !emailOpt.checked && !waOpt.checked ? 'Please choose email, WhatsApp, or both for your batch updates.' : '');
        submit.textContent = removing ? 'Request removal from waitlist' : 'Join the waitlist';
        if (error) error.textContent = '';
      };
      [emailOpt, waOpt, request].forEach((input) => input.addEventListener('change', sync));
      phone.addEventListener('input', sync);
      phone.addEventListener('blur', () => { if (!phone.disabled) phone.value = compactPhone(); sync(); });
      form.addEventListener('invalid', (event) => { if (error) error.textContent = event.target.validationMessage; }, true);
      form.addEventListener('submit', (event) => {
        sync();
        if (!form.checkValidity()) { event.preventDefault(); form.reportValidity(); return; }
        if (!phone.disabled) phone.value = compactPhone();
        const timestamp = form.querySelector('[data-submit-time]');
        if (timestamp) timestamp.value = new Date().toISOString();
        // Do not bypass Shopify's captcha, create a fake success state, or send messages here.
      });
      sync();
      submit.disabled = false;
    });
  };
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-uku-interest]');
    if (!trigger) return;
    const form = document.querySelector('form.uku-waitlist-form');
    const select = form?.querySelector('[data-product-interest]');
    if (!select) return;
    const mode = form.querySelector('[data-waitlist-request]');
    if (mode) { mode.value = 'Join or update the waitlist'; mode.dispatchEvent(new Event('change', { bubbles: true })); }
    const requested = trigger.dataset.ukuInterest;
    if (Array.from(select.options).some((option) => option.value === requested)) {
      select.value = requested;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise());
  else initialise();
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
